(function (window) {
	window.FSJSC_profile = function (form, callback) {
		var thirdParty = {
			LZString: (function () {

				// private property
				var f = String.fromCharCode;
				var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
				var baseReverseDic = {};

				function getBaseValue(alphabet, character) {
					if (!baseReverseDic[alphabet]) {
						baseReverseDic[alphabet] = {};
						for (var i = 0; i < alphabet.length; i++) {
							baseReverseDic[alphabet][alphabet.charAt(i)] = i;
						}
					}
					return baseReverseDic[alphabet][character];
				}

				var LZString = {
					compressToBase64: function (input) {
						if (input == null) return "";
						var res = LZString._compress(input, 6, function (a) {
							return keyStrBase64.charAt(a);
						});
						switch (res.length % 4) { // To produce valid Base64
							default: // When could this happen ?
							case 0 :
								return res;
							case 1 :
								return res + "===";
							case 2 :
								return res + "==";
							case 3 :
								return res + "=";
						}
					},
					_compress: function (uncompressed, bitsPerChar, getCharFromInt) {
						if (uncompressed == null) return "";
						var i, value,
							context_dictionary = {},
							context_dictionaryToCreate = {},
							context_c = "",
							context_wc = "",
							context_w = "",
							context_enlargeIn = 2, // Compensate for the first entry which should not count
							context_dictSize = 3,
							context_numBits = 2,
							context_data = [],
							context_data_val = 0,
							context_data_position = 0,
							ii;

						for (ii = 0; ii < uncompressed.length; ii += 1) {
							context_c = uncompressed.charAt(ii);
							if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
								context_dictionary[context_c] = context_dictSize++;
								context_dictionaryToCreate[context_c] = true;
							}

							context_wc = context_w + context_c;
							if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
								context_w = context_wc;
							} else {
								if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
									if (context_w.charCodeAt(0) < 256) {
										for (i = 0; i < context_numBits; i++) {
											context_data_val = (context_data_val << 1);
											if (context_data_position == bitsPerChar - 1) {
												context_data_position = 0;
												context_data.push(getCharFromInt(context_data_val));
												context_data_val = 0;
											} else {
												context_data_position++;
											}
										}
										value = context_w.charCodeAt(0);
										for (i = 0; i < 8; i++) {
											context_data_val = (context_data_val << 1) | (value & 1);
											if (context_data_position == bitsPerChar - 1) {
												context_data_position = 0;
												context_data.push(getCharFromInt(context_data_val));
												context_data_val = 0;
											} else {
												context_data_position++;
											}
											value = value >> 1;
										}
									} else {
										value = 1;
										for (i = 0; i < context_numBits; i++) {
											context_data_val = (context_data_val << 1) | value;
											if (context_data_position == bitsPerChar - 1) {
												context_data_position = 0;
												context_data.push(getCharFromInt(context_data_val));
												context_data_val = 0;
											} else {
												context_data_position++;
											}
											value = 0;
										}
										value = context_w.charCodeAt(0);
										for (i = 0; i < 16; i++) {
											context_data_val = (context_data_val << 1) | (value & 1);
											if (context_data_position == bitsPerChar - 1) {
												context_data_position = 0;
												context_data.push(getCharFromInt(context_data_val));
												context_data_val = 0;
											} else {
												context_data_position++;
											}
											value = value >> 1;
										}
									}
									context_enlargeIn--;
									if (context_enlargeIn == 0) {
										context_enlargeIn = Math.pow(2, context_numBits);
										context_numBits++;
									}
									delete context_dictionaryToCreate[context_w];
								} else {
									value = context_dictionary[context_w];
									for (i = 0; i < context_numBits; i++) {
										context_data_val = (context_data_val << 1) | (value & 1);
										if (context_data_position == bitsPerChar - 1) {
											context_data_position = 0;
											context_data.push(getCharFromInt(context_data_val));
											context_data_val = 0;
										} else {
											context_data_position++;
										}
										value = value >> 1;
									}


								}
								context_enlargeIn--;
								if (context_enlargeIn == 0) {
									context_enlargeIn = Math.pow(2, context_numBits);
									context_numBits++;
								}
								// Add wc to the dictionary.
								context_dictionary[context_wc] = context_dictSize++;
								context_w = String(context_c);
							}
						}

						// Output the code for w.
						if (context_w !== "") {
							if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
								if (context_w.charCodeAt(0) < 256) {
									for (i = 0; i < context_numBits; i++) {
										context_data_val = (context_data_val << 1);
										if (context_data_position == bitsPerChar - 1) {
											context_data_position = 0;
											context_data.push(getCharFromInt(context_data_val));
											context_data_val = 0;
										} else {
											context_data_position++;
										}
									}
									value = context_w.charCodeAt(0);
									for (i = 0; i < 8; i++) {
										context_data_val = (context_data_val << 1) | (value & 1);
										if (context_data_position == bitsPerChar - 1) {
											context_data_position = 0;
											context_data.push(getCharFromInt(context_data_val));
											context_data_val = 0;
										} else {
											context_data_position++;
										}
										value = value >> 1;
									}
								} else {
									value = 1;
									for (i = 0; i < context_numBits; i++) {
										context_data_val = (context_data_val << 1) | value;
										if (context_data_position == bitsPerChar - 1) {
											context_data_position = 0;
											context_data.push(getCharFromInt(context_data_val));
											context_data_val = 0;
										} else {
											context_data_position++;
										}
										value = 0;
									}
									value = context_w.charCodeAt(0);
									for (i = 0; i < 16; i++) {
										context_data_val = (context_data_val << 1) | (value & 1);
										if (context_data_position == bitsPerChar - 1) {
											context_data_position = 0;
											context_data.push(getCharFromInt(context_data_val));
											context_data_val = 0;
										} else {
											context_data_position++;
										}
										value = value >> 1;
									}
								}
								context_enlargeIn--;
								if (context_enlargeIn == 0) {
									context_enlargeIn = Math.pow(2, context_numBits);
									context_numBits++;
								}
								delete context_dictionaryToCreate[context_w];
							} else {
								value = context_dictionary[context_w];
								for (i = 0; i < context_numBits; i++) {
									context_data_val = (context_data_val << 1) | (value & 1);
									if (context_data_position == bitsPerChar - 1) {
										context_data_position = 0;
										context_data.push(getCharFromInt(context_data_val));
										context_data_val = 0;
									} else {
										context_data_position++;
									}
									value = value >> 1;
								}


							}
							context_enlargeIn--;
							if (context_enlargeIn == 0) {
								context_enlargeIn = Math.pow(2, context_numBits);
								context_numBits++;
							}
						}

						// Mark the end of the stream
						value = 2;
						for (i = 0; i < context_numBits; i++) {
							context_data_val = (context_data_val << 1) | (value & 1);
							if (context_data_position == bitsPerChar - 1) {
								context_data_position = 0;
								context_data.push(getCharFromInt(context_data_val));
								context_data_val = 0;
							} else {
								context_data_position++;
							}
							value = value >> 1;
						}

						// Flush the last char
						while (true) {
							context_data_val = (context_data_val << 1);
							if (context_data_position == bitsPerChar - 1) {
								context_data.push(getCharFromInt(context_data_val));
								break;
							}
							else context_data_position++;
						}
						return context_data.join('');
					},
					decompressFromBase64: function (input) {
						if (input == null) return "";
						if (input == "") return null;
						return LZString._decompress(input.length, 32, function (index) {
							return getBaseValue(keyStrBase64, input.charAt(index));
						});
					},
					_decompress: function (length, resetValue, getNextValue) {
						var dictionary = [],
							next,
							enlargeIn = 4,
							dictSize = 4,
							numBits = 3,
							entry = "",
							result = [],
							i,
							w,
							bits, resb, maxpower, power,
							c,
							data = {val: getNextValue(0), position: resetValue, index: 1};

						for (i = 0; i < 3; i += 1) {
							dictionary[i] = i;
						}

						bits = 0;
						maxpower = Math.pow(2, 2);
						power = 1;
						while (power != maxpower) {
							resb = data.val & data.position;
							data.position >>= 1;
							if (data.position == 0) {
								data.position = resetValue;
								data.val = getNextValue(data.index++);
							}
							bits |= (resb > 0 ? 1 : 0) * power;
							power <<= 1;
						}

						switch (next = bits) {
							case 0:
								bits = 0;
								maxpower = Math.pow(2, 8);
								power = 1;
								while (power != maxpower) {
									resb = data.val & data.position;
									data.position >>= 1;
									if (data.position == 0) {
										data.position = resetValue;
										data.val = getNextValue(data.index++);
									}
									bits |= (resb > 0 ? 1 : 0) * power;
									power <<= 1;
								}
								c = f(bits);
								break;
							case 1:
								bits = 0;
								maxpower = Math.pow(2, 16);
								power = 1;
								while (power != maxpower) {
									resb = data.val & data.position;
									data.position >>= 1;
									if (data.position == 0) {
										data.position = resetValue;
										data.val = getNextValue(data.index++);
									}
									bits |= (resb > 0 ? 1 : 0) * power;
									power <<= 1;
								}
								c = f(bits);
								break;
							case 2:
								return "";
						}
						dictionary[3] = c;
						w = c;
						result.push(c);
						while (true) {
							if (data.index > length) {
								return "";
							}

							bits = 0;
							maxpower = Math.pow(2, numBits);
							power = 1;
							while (power != maxpower) {
								resb = data.val & data.position;
								data.position >>= 1;
								if (data.position == 0) {
									data.position = resetValue;
									data.val = getNextValue(data.index++);
								}
								bits |= (resb > 0 ? 1 : 0) * power;
								power <<= 1;
							}

							switch (c = bits) {
								case 0:
									bits = 0;
									maxpower = Math.pow(2, 8);
									power = 1;
									while (power != maxpower) {
										resb = data.val & data.position;
										data.position >>= 1;
										if (data.position == 0) {
											data.position = resetValue;
											data.val = getNextValue(data.index++);
										}
										bits |= (resb > 0 ? 1 : 0) * power;
										power <<= 1;
									}

									dictionary[dictSize++] = f(bits);
									c = dictSize - 1;
									enlargeIn--;
									break;
								case 1:
									bits = 0;
									maxpower = Math.pow(2, 16);
									power = 1;
									while (power != maxpower) {
										resb = data.val & data.position;
										data.position >>= 1;
										if (data.position == 0) {
											data.position = resetValue;
											data.val = getNextValue(data.index++);
										}
										bits |= (resb > 0 ? 1 : 0) * power;
										power <<= 1;
									}
									dictionary[dictSize++] = f(bits);
									c = dictSize - 1;
									enlargeIn--;
									break;
								case 2:
									return result.join('');
							}

							if (enlargeIn == 0) {
								enlargeIn = Math.pow(2, numBits);
								numBits++;
							}

							if (dictionary[c]) {
								entry = dictionary[c];
							} else {
								if (c === dictSize) {
									entry = w + w.charAt(0);
								} else {
									return null;
								}
							}
							result.push(entry);

							// Add w+entry[0] to the dictionary.
							dictionary[dictSize++] = w + entry.charAt(0);
							enlargeIn--;

							w = entry;

							if (enlargeIn == 0) {
								enlargeIn = Math.pow(2, numBits);
								numBits++;
							}

						}
					}
				};
				return LZString;
			})()

		}

		function setCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + "; " + expires;
		}

		function getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1);
				if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
			}
			return "";
		}

		function getCanvasFingerprint() {
			var result = [];
			// Very simple now, need to make it more complex (geo shapes etc)
			var canvas = document.createElement("canvas");
			canvas.width = 2000;
			canvas.height = 200;
			canvas.style.display = "inline";
			if (canvas.getContext) {
				var ctx = canvas.getContext("2d");
				// detect browser support of canvas winding
				// http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
				// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
				ctx.rect(0, 0, 10, 10);
				ctx.rect(2, 2, 6, 6);
				result.push("canvas winding:" + ((ctx.isPointInPath(5, 5, "evenodd") === false) ? "yes" : "no"));


				ctx.textBaseline = "alphabetic";
				ctx.fillStyle = "#f60";
				ctx.fillRect(125, 1, 62, 20);
				ctx.fillStyle = "#069";
				ctx.font = "11pt Arial";
				ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 2, 15);
				ctx.fillStyle = "rgba(102, 204, 0, 0.2)";
				ctx.font = "18pt Arial";
				ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 4, 45);

				// canvas blending
				// http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
				// http://jsfiddle.net/NDYV8/16/
				ctx.globalCompositeOperation = "multiply";
				ctx.fillStyle = "rgb(255,0,255)";
				ctx.beginPath();
				ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
				ctx.closePath();
				ctx.fill();
				ctx.fillStyle = "rgb(0,255,255)";
				ctx.beginPath();
				ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
				ctx.closePath();
				ctx.fill();
				ctx.fillStyle = "rgb(255,255,0)";
				ctx.beginPath();
				ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
				ctx.closePath();
				ctx.fill();
				ctx.fillStyle = "rgb(255,0,255)";
				// canvas winding
				// http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
				// http://jsfiddle.net/NDYV8/19/
				ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
				ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
				ctx.fill("evenodd");

				//result.push("canvas fp:" + canvas.toDataURL());
				return result.join("~");

			} else {
				return "canvas no supported";
			}
		}

		function webRtcSupport() {
			var prefix;
			var version;

			if (window.mozRTCPeerConnection || navigator.mozGetUserMedia) {
				prefix = 'moz';
				version = parseInt(navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1], 10);
			} else if (window.webkitRTCPeerConnection || navigator.webkitGetUserMedia) {
				prefix = 'webkit';
				version = navigator.userAgent.match(/Chrom(e|ium)/) && parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2], 10);
			}

			var PC = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
			var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia;

			return !!PC && !!getUserMedia;
		}

		function getLocalIpAddress(callback) {
			window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;   //compatibility for firefox and chrome
			var pc = new RTCPeerConnection ({iceServers: []}), noop = function () {
			};
			pc.createDataChannel ("");    //create a bogus data channel
			pc.createOffer (pc.setLocalDescription.bind (pc), noop);    // create offer and set local description
			pc.onicecandidate = function (ice) {  //listen for candidate events
				try {
					if (!ice || !ice.candidate || !ice.candidate.candidate) {
						callback ('na');
					}
					var ipAddress = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec (ice.candidate.candidate)[1];
					callback (ipAddress);
					pc.onicecandidate = noop;
				} catch (e) {
					callback ('na');
					pc.onicecandidate = noop;
					console.log (e.name + ": " + e.message);
				}
			};
		}

		function getAudioVideoDeviceIds(subcallback) {
			var result = [];
			if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
				result = "enumerateDevices() not supported.";
				subcallback(result);
			} else {
				// List cameras and microphones.
				navigator.mediaDevices.enumerateDevices().then(function (devices) {
					devices.forEach(function (device) {
						result.push(device.kind + ": " + device.label + " id = " + device.deviceId);
					});
					subcallback(result);
				}).catch (function(err) {
					result = 'enumerateDevices() not supported.';
					subcallback (result);
					console.log (err.name + ": " + err.message);
				});
			}
		}

		function get_browser_info() {
			var ua = navigator.userAgent, tem, M = ua.match (/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
			if (/trident/i.test (M[1])) {
				tem = /\brv[ :]+(\d+)/g.exec (ua) || [];
				return {name: 'IE ', version: (tem[1] || '')};
			}
			if (M[1] === 'Chrome') {
				tem = ua.match (/\bOPR\/(\d+)/);
				if (tem != null) {
					return {name: 'Opera', version: tem[1]};
				}
			}
			M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
			if ((tem = ua.match (/version\/(\d+)/i)) != null) {
				M.splice (1, 1, tem[1]);
			}
			return {
				name: M[0],
				version: M[1]
			};
		}

		function get_os() {
			var OSName = "unknown OS";
			if (navigator.appVersion.indexOf ("Win") != -1) OSName = "Windows";
			if (navigator.appVersion.indexOf ("Mac") != -1) OSName = "MacOS";
			if (navigator.appVersion.indexOf ("X11") != -1) OSName = "UNIX";
			if (navigator.appVersion.indexOf ("Linux") != -1) OSName = "Linux";

			return OSName;
		}

		function isDefined(property) {
			// workaround https://github.com/douglascrockford/JSLint/commit/24f63ada2f9d7ad65afc90e6d949f631935c2480
			var propertyType = typeof property;
			return propertyType !== 'undefined';
		}

		function getJavaVersions() {
			var i, mimeType,
				pluginMap = {
					java: 'application/x-java-vm'
				};
			var answer = '';
			//if (!((new RegExp('MSIE')).test(navigator.userAgent)))
			if (navigator.mimeTypes && navigator.mimeTypes.length) {
				for (i in pluginMap) {
					mimeType = navigator.mimeTypes[pluginMap[i]];
					if (mimeType) {
						var old_array = mimeType.enabledPlugin;
						for (var j = 0; j < old_array.length; j++) {
							answer += old_array[j].type;
							if (j < old_array.length - 1) {
								answer += '|';
							}
						}
					}
				}
			}
			if (answer == '') {
				// IE6/IE7 navigator.javaEnabled can't be aliased, so test directly
				if (typeof navigator.javaEnabled !== 'unknown' &&
					isDefined (navigator.javaEnabled) &&
					navigator.javaEnabled ()) {
					answer = 'JAVA NOT FOUND';
				}
			}
			if (answer == '') {
				answer = 'JAVA NOT FOUND';
			}
			return answer;
		}

		function getLocale() {
			return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || "Locale not found";
		}

		function getInstalledFonts() {

			// a font will be compared against all the three default fonts.
			// and if it doesn't match all 3 then that font is not available.
			var baseFonts = ["monospace", "sans-serif", "serif"];

			var fontList = JSON.parse (thirdParty.LZString.decompressFromBase64 ("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"));

			//we use m or w because these two characters take up the maximum width.
			// And we use a LLi so that the same matching fonts can get separated
			var testString = "mmmmmmmmmmlli";

			//we test using 72px font size, we may use any size. I guess larger the better.
			var testSize = "72px";

			var h = document.getElementsByTagName ("body")[0];

			// div to load spans for the base fonts
			var baseFontsDiv = document.createElement ("div");

			// div to load spans for the fonts to detect
			var fontsDiv = document.createElement ("div");

			var defaultWidth = {};
			var defaultHeight = {};

			// creates a span where the fonts will be loaded
			var createSpan = function () {
				var s = document.createElement ("span");
				/*
				 * We need this css as in some weird browser this
				 * span elements shows up for a microSec which creates a
				 * bad user experience
				 */
				s.style.position = "absolute";
				s.style.left = "-9999px";
				s.style.fontSize = testSize;
				s.style.lineHeight = "normal";
				s.innerHTML = testString;
				return s;
			};

			// creates a span and load the font to detect and a base font for fallback
			var createSpanWithFonts = function (fontToDetect, baseFont) {
				var s = createSpan ();
				s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
				return s;
			};

			// creates spans for the base fonts and adds them to baseFontsDiv
			var initializeBaseFontsSpans = function () {
				var spans = [];
				for (var index = 0, length = baseFonts.length; index < length; index++) {
					var s = createSpan ();
					s.style.fontFamily = baseFonts[index];
					baseFontsDiv.appendChild (s);
					spans.push (s);
				}
				return spans;
			};

			// creates spans for the fonts to detect and adds them to fontsDiv
			var initializeFontsSpans = function () {
				var spans = {};
				for (var i = 0, l = fontList.length; i < l; i++) {
					var fontSpans = [];
					for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
						var s = createSpanWithFonts (fontList[i], baseFonts[j]);
						fontsDiv.appendChild (s);
						fontSpans.push (s);
					}
					spans[fontList[i]] = fontSpans; // Stores {fontName : [spans for that font]}
				}
				return spans;
			};

			// checks if a font is available
			var isFontAvailable = function (fontSpans) {
				var detected = false;
				for (var i = 0; i < baseFonts.length; i++) {
					detected = (fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]]);
					if (detected) {
						return detected;
					}
				}
				return detected;
			};

			// create spans for base fonts
			var baseFontsSpans = initializeBaseFontsSpans ();

			// add the spans to the DOM
			h.appendChild (baseFontsDiv);

			// get the default width for the three base fonts
			for (var index = 0, length = baseFonts.length; index < length; index++) {
				defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
				defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
			}

			// create spans for fonts to detect
			var fontsSpans = initializeFontsSpans ();

			// add all the spans to the DOM
			h.appendChild (fontsDiv);

			// check available fonts
			var available = [];
			for (var i = 0, l = fontList.length; i < l; i++) {
				if (isFontAvailable (fontsSpans[fontList[i]])) {
					available.push (fontList[i]);
				}
			}

			// remove spans from DOM
			h.removeChild (fontsDiv);
			h.removeChild (baseFontsDiv);

			return available;

		}

		var makeUUID = function (format) {
			return format.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		};


		// package up required data and submit to event api ...
		try {
			var browser = get_browser_info ();
			var cookieId = getCookie('wtid');
			if (cookieId == "") {
				var uuid = makeUUID('xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx');
				setCookie('wtid', uuid, 1095);
			}

			var fingerprint = {
				// browser
				1: browser.name,
				//browser_version
				2: browser.version,
				//os
				3: get_os (),
				//userAgent detection
				4: window.navigator.userAgent,
				// timezone offset
				5: new Date ().getTimezoneOffset (),
				//screen
				6: {
					1: window.screen.width + 'x' + window.screen.height,
					2: window.screen.availWidth + 'x' + window.screen.availHeight,
					3: window.innerWidth + 'x' + window.innerHeight,
					4: window.screen.colorDepth,
					5: window.screen.pixelDepth
				},
				//jreVersions
				7: getJavaVersions (),
				// locale
				8: getLocale (),
				// installed fonts
				9: getInstalledFonts (),
				// canvas fingerprint
				10: getCanvasFingerprint (),
				//cookieId
				11: getCookie ('wtid'),
			};

			if (webRtcSupport()) {
				// get audio & video hardware ids
				getAudioVideoDeviceIds(
					function (audioVideoDeviceIds) {
						fingerprint[12] = audioVideoDeviceIds;
						callback(form, fingerprint);
					});
			} else {
				fingerprint[12] = thirdParty.LZString.decompressFromBase64 ("HIewLgBAhgRgNgUwmEEDmDJQK4BMCWIA9AG764KoAWUATrgO51ICSuAzhABQDqCMAJQAqAYQgA7cBHbYADrJC0wCXAEogA==");
				callback(form,fingerprint);
			}
		} catch (err) {
			console.log(err);
			var fakeDeviceId = ["fake", "device", "id"];
			callback (form, fakeDeviceId);
		}
	}
})(window);

define("deviceId/deviceId", function(){});

